<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <!-- Card header -->
        <card-header :title="$router.currentRoute.meta.title" />
        <!-- Card body -->
        <form role="form" @submit.prevent="update">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <div v-if="serverError" class="alert alert-danger">
                  <strong>{{ $t('labels.error') }} : </strong> {{ serverError }}
                </div>
              </div>
            </div>
            <div class="row" v-if="isItemFound()">
              <select-captain-bonus-types v-model="type" :options="{ id: 'captain_bonus_type', label: 'type', error: fieldErrors.type }"/>
              <select-captain-bonus-owner-types v-model="owner_type" :options="{ id: 'captain_bonus_owner_type', label: 'owner_type', error: fieldErrors.ownerType }"/>
              <input-number v-model="owner_id" :options="{ id: 'owner_id', step: 1, label: 'owner_id', error: fieldErrors.ownerId }"/>
              <input-text v-model="name" :options="{ id: 'name', label: 'name', error: fieldErrors.name }"/>
              <input-textarea v-model="description" :options="{ id: 'description', label: 'description', error: fieldErrors.description }"/>
              <input-number v-model="revenue" :options="{ id: 'revenue', label: 'revenue', disabled: true, error: fieldErrors.revenue }"/>
              <input-datetime v-model="from_date" :options="{ id: 'from_date', label: 'from_date', error: fieldErrors.fromDate }"/>
              <input-datetime v-model="to_date" :options="{ id: 'to_date', label: 'to_date', error: fieldErrors.toDate }"/>
              <input-number v-model="whenDeliveredOrdersReaches" :options="{ id: 'whenDeliveredOrdersReaches', step: 1, transPrefix: `${transPrefix}.fields`, label: 'when_delivered_orders_reaches', error: fieldErrors.deliveryBonusData }"/>
            </div>
          </div>
          <!-- Card footer -->
          <div class="card-footer">
            <div class="row">
              <div class="col text-right">
                <router-link :to="{ name: `${routePrefix}.index`}"  class="btn btn-neutral btn-sm">
                  <i class="fa fa-arrow-left"></i>
                </router-link>
                <button v-if="isItemFound()" type="submit" class="btn btn-primary btn-sm" :disabled="loading">
                  <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                  <i class="fa fa-save"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  import { CAPTAIN_BONUSES_SHOW as CRUD_ACTION_SHOW,CAPTAIN_BONUSES_UPDATE as CRUD_ACTION_UPDATE } from 'actions/captain_bonuses';
  const CRUD_CODE="captain_bonuses";
  export default {
    name: "CaptainBonusEdit",
    data(){
      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        id:this.$router.currentRoute.params.id,
        type: '',
        owner_type: '',
        owner_id: '',
        name:"",
        description:"",
        revenue: '',
        whenDeliveredOrdersReaches:"",
        from_date: '',
        to_date: '',
        serverError: '',
        fieldErrors: {},
        responseStatus:'',
        formMode: 'edit',
        loading: false,
      }
    },
    mounted() {
      this.getItem();
    },
    methods: {
      isItemFound(){
        return this.responseStatus!==404;
      },
      getItem(){
        this.$store.dispatch(CRUD_ACTION_SHOW,{
          id: this.id,
        }).then(response=>{
          this.type=response.data.type;
          this.owner_type=response.data.ownerType;
          this.owner_id=response.data.ownerId;
          this.name=response.data.name;
          this.description=response.data.description;
          this.revenue=response.data.revenue;
          this.enabled=response.data.enabled;
          this.expired=response.data.expired;
          this.whenDeliveredOrdersReaches=response.data.data?response.data.data.whenDeliveredOrdersReaches:null;
          this.from_date=response.data.fromDate?this.$moment(response.data.fromDate).format("Y-MM-DDTHH:mm"):"";
          this.to_date=response.data.toDate?this.$moment(response.data.toDate).format("Y-MM-DDTHH:mm"):"";
        }).catch(error => {
          this.loading = false;
          this.serverError='';

          if(error.response){
            this.responseStatus=error.response.status;
            let responseData=error.response.data;

            if(responseData.errors){
              this.fieldErrors=responseData.errors;
            }else{
              this.serverError = 'Invalid Request.'
            }
          }else{
            this.serverError = this.$i18n.t("messages.no_internet_connection");
          }

          if(this.fieldErrors.error){
            this.serverError = this.fieldErrors.error;
          }
        });
      },
      prepareDeliveryBonusRequestData() {
        let data={};
        if (["DELIVERY"].includes(this.type) && this.sanitizeField('whenDeliveredOrdersReaches')) {
          data = {
            "deliveryBonusData": {
              "whenDeliveredOrdersReaches": this.sanitizeField('whenDeliveredOrdersReaches'),
            }
          };
        }
        return data;
      },
      prepareRequestData(){
        return {
          type: this.sanitizeField('type'),
          ownerType: this.sanitizeField('owner_type'),
          ownerId: this.sanitizeField('owner_id'),
          name: this.sanitizeField('name'),
          description: this.sanitizeField('description'),
          revenue: this.sanitizeField('revenue'),
          toDate: this.prepareDateTime('to_date'),
          fromDate: this.prepareDateTime('from_date'),
          ...this.prepareDeliveryBonusRequestData(),
        }
      },
      update() {
        this.loading = true;
        this.$store.dispatch(CRUD_ACTION_UPDATE, {
          id: this.id,
          data: {
            ...this.prepareRequestData()
          },
        })
        .then(() => {
          swal({
            icon: 'success',
            text: this.$i18n.t("messages.update_successfully"),
            buttons:false,
            timer: 5000
          });
          this.$router.push({ name: `${this.routePrefix}.index` })
        })
        .catch(error => {
          this.loading = false;
          this.fieldErrors={};
          this.serverError='';

          if(error.response){
            this.responseStatus=error.response.status;
            let responseData=error.response.data;

            if(responseData.errors){
              this.fieldErrors=responseData.errors;
            }else{
              this.serverError = 'Invalid Request.'
            }
          }else{
            this.serverError = this.$i18n.t("messages.no_internet_connection");
          }

          if(this.fieldErrors.error){
            this.serverError = this.fieldErrors.error;
          }
        })
      }
    },
  };
</script>
